import { render, staticRenderFns } from "./SettingsEmployees.vue?vue&type=template&id=5d0ef9ca&"
import script from "./SettingsEmployees.vue?vue&type=script&lang=js&"
export * from "./SettingsEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0ef9ca')) {
      api.createRecord('5d0ef9ca', component.options)
    } else {
      api.reload('5d0ef9ca', component.options)
    }
    module.hot.accept("./SettingsEmployees.vue?vue&type=template&id=5d0ef9ca&", function () {
      api.rerender('5d0ef9ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/SettingsEmployees.vue"
export default component.exports